import styled from '@emotion/styled';
import { color, COLOR_VARIANTS } from '@tajawal/ct-web-design-system';

const BaggageTooltipWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  .MuiTypography-body2 {
    color: ${color(COLOR_VARIANTS.WHITE)};
  }
  .MuiTypography-captionReg {
    color: ${color(COLOR_VARIANTS.GAINSBORO)};
  }
`;

const BaggageInfoBoxWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export default {
  BaggageTooltipWrapper,
  BaggageInfoBoxWrapper,
};
